import AbstractRuleTemplateAction from "./AbstractRuleTemplateAction.js";

/**
 * Action to perform in order to update an existing new rule template
 */
export default class UpdateRuleTemplateAction extends AbstractRuleTemplateAction {
	appendTo(bulkRuleTemplateAction) {
		bulkRuleTemplateAction.appendUpdateRuleAction({
			ruleTemplate: this._ruleTemplate,
		});
	}
}
